import './App.css';
import React from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Home from './components/Home'
import SignUp from './components/SignUp'
import Cookies from 'js-cookie';
import Login from './components/Login';
import CoachHome from './components/Coach/CoachHome';
import Layout from './components/Layout';
import PasswordChange from './components/PasswordChange';
import Programs from './components/Admin/Programs';
import Staff from './components/Admin/Staff';
import Metrics from './components/Admin/Metrics';
import Payroll from './components/Admin/Payroll';
import Retention from './components/Admin/Retention';
import EquipmentPlanning from './components/Admin/EquipmentPlanning';
import BreakEven from './components/Admin/BreakEven';

const ProtectedRoute = ({ children }) => {
  const userId = Cookies.get('userId')
  if (!userId) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

function App() {
  return (
    <Router>
      <div>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <Layout>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/" element={
              <ProtectedRoute><Home /></ProtectedRoute>
            } />
            <Route path="/admin" element={<Navigate to="/programs" replace />} />
            <Route path="/programs" element={
              <ProtectedRoute><Programs /></ProtectedRoute>
            } />
            <Route path="/staff" element={
              <ProtectedRoute><Staff /></ProtectedRoute>
            } />
            <Route path="/metrics" element={
              <ProtectedRoute><Metrics /></ProtectedRoute>
            } />
            <Route path="/payroll" element={
              <ProtectedRoute><Payroll /></ProtectedRoute>
            } />
            <Route path="/retention" element={
              <ProtectedRoute><Retention /></ProtectedRoute>
            } />
            <Route path="/equipment-planning" element={
              <ProtectedRoute><EquipmentPlanning /></ProtectedRoute>
            } />
            <Route path="/break-even" element={
              <ProtectedRoute><BreakEven /></ProtectedRoute>
            } />
            <Route path="/coach" element={
              <ProtectedRoute><CoachHome /></ProtectedRoute>
            } />
            <Route path="/changePassword" element={
              <ProtectedRoute><PasswordChange /></ProtectedRoute>
            } />
            <Route render={() => <h1>Page not found!</h1>} />
          </Routes>
        </Layout>
      </div>
    </Router>
  );
}

export default App;
